<template>
    <div class="person-index">
        <!-- 查看详情弹出框 -->
        <div class="content-continer">
            <div class="continer-top base-content">
                <!-- 第一行 -->
                <el-row :gutter="10">
                    <el-col :span="8">
                        <p>
                            <span class="input-text">手机号：</span>
                            <input type="text" v-model="mobile" placeholder="请输入手机号" />

                        </p>
                    </el-col>
                    <el-col :span="11">
                        <p>
                            <span class="input-text"> 验证码：</span>
                            <input type="text" class="code" placeholder="输入验证码" v-model="smsCode" />
                            <el-button type="primary" @click="send" v-if="Verification">获取验证码</el-button>
                            <el-button type="info" disabled v-if="!Verification">{{time}}s后重新获取</el-button>
                        </p>
                    </el-col>

                    <el-col :span="5" style="text-align:right;">
                        <div class="grid-content bg-purple">
                            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                            <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div v-if="!peviewstatus" class="center" style="margin-top: 100px;">
                <img src="../assets/company-person-add.png">
                <p class="tips">请输入手机号查询CRC进行添加！</p>
            </div>

            <!-- 详情 -->
            <div v-if="peviewstatus" class="peview" style="padding-top: 0px;margin-top: 30px;">
                <ul style="margin-bottom: 100px;" id="demo">
                    <li>
                        <div class="left peview-img"><img :src="imgurl+personlist.workImgUrl" style="height:120px;">
                        </div>
                        <div class="left">
                            <p class="peview-name">{{personlist.cnName}}</p>
                            <p class="peview-xq">
                                <span><img src="../assets/phone.png">{{personlist.mobile}}</span>
                                <span><img src="../assets/old.png">{{personlist.age}}岁</span>
                                <span><img src="../assets/address.png">{{personlist.city}}</span>
                            </p>
                        </div>
                        <div style="clear:both"></div>

                    </li>
                    <!-- 教育经历************************************************************************ -->
                    <li>
                        <div class="peview-list-title">教育经历</div>
                        <ul>
                            <li v-for="(item,index) in personlist.eduList">
                                <div class="peview-list-title-name">{{item.schoolName}}</div>
                                <div class="peview-list-ed-msg">
                                    <span>{{item.startDate}}-{{item.endDate}}</span>|
                                    <span>{{item.eduLevelDesc}}</span>|
                                    <span v-if="item.isGeneral==1">统招</span>
                                    <span v-if="item.isGeneral==0">自考</span>|
                                    <span>{{item.majorName}}</span>
                                </div>
                            </li>
                        </ul>
                        <ul v-if="personlist.eduList==''">
                            <li>暂无数据</li>
                        </ul>
                        <img src="../assets/geren-icon1.png" class="peview-b-icon">
                    </li>
                    <!-- 培训经历***************************************************************************** -->
                    <li>
                        <div class="peview-list-title">培训经历</div>
                        <ul>
                            <li v-for="(item,index) in personlist.trainList">
                                <div class="peview-list-title-name">{{item.schoolName}}</div>
                                <div class="peview-list-ed-msg">
                                    <span>{{item.startDate}}-{{item.endDate}}</span>|
                                    <span>{{item.courseName}}</span>
                                </div>
                            </li>
                        </ul>
                        <ul v-if="personlist.trainList==''">
                            <li>暂无数据</li>
                        </ul>
                        <img src="../assets/geren-icon1.png" class="peview-b-icon">
                    </li>
                    <!-- 获得证书************************************************************************************* -->
                    <li>
                        <div class="peview-list-title">获得证书</div>
                        <ul>
                            <li v-for="(item,index) in personlist.certificateList" :key="index">
                                <div class="peview-list-title-name">{{item.certificateName}}</div>
                                <div class="peview-list-ed-msg">
                                    <span>{{item.getTime}}</span>|
                                    <span>{{item.certificateName}}</span>
                                </div>
                            </li>
                        </ul>
                        <ul v-if="personlist.certificateList==''">
                            <li>暂无数据</li>
                        </ul>
                        <img src="../assets/geren-icon1.png" class="peview-b-icon">
                    </li>
                    <!-- 项目经历******************************************************************************************* -->
                    <li>
                        <div class="peview-list-title">项目经历（个人备案）</div>
                        <img src="../assets/geren-icon1.png" class="peview-b-icon">
                        <ul>
                            <li v-for="(item,index) in personlist.projectExpList0" :key="index">
                                <div class="peview-list-title-name">{{item.projectName}}</div>
                                <div class="peview-list-ed-msg">
                                    <span>{{item.startDate}}-{{item.endDate}}</span>|
                                    <span>{{item.specialtyName}}</span>
                                </div>
                                <ul class="peview-item">
                                    <li>
                                        <p>公司名称</p>
                                        <p>{{item.smoName}}</p>
                                    </li>
                                    <li>
                                        <p>专业名称</p>
                                        <p>{{item.specialtyName}}</p>
                                    </li>
                                    <li v-if="item.jobTitle">
                                        <p>职位名称</p>
                                        <p>{{item.jobTitle}}</p>
                                    </li>
                                    <li v-if="item.phaseDesc">
                                        <p>项目类型</p>
                                        <p>{{item.phaseDesc}}</p>
                                    </li>
                                    <li v-if="item.managerName">
                                        <p>证明人</p>
                                        <p>{{item.managerName}}</p>
                                    </li>
                                    <li v-if="item.managerMobile">
                                        <p>证明人电话</p>
                                        <p>{{item.managerMobile}}</p>
                                    </li>
                                    <li style="display:block;" v-if="item.workDesc">
                                        <p>项目描述</p>
                                        <p>{{item.workDesc}}</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul v-if="personlist.projectExpList0==''">
                            <li>暂无数据</li>
                        </ul>
                    </li>
                    <li>
                        <div class="peview-list-title">项目经历(公司备案)</div>
                        <img src="../assets/geren-icon2.png" class="peview-b-icon">
                        <ul>

                            <li v-for="(item,index) in personlist.projectExpList1" :key="index">
                                <div class="peview-list-title-name">{{item.projectName}}</div>
                                <div class="peview-list-ed-msg">
                                    <span>{{item.startDate}}-{{item.endDate}}</span>|
                                    <span>{{item.specialtyName}}</span>
                                </div>
                                <ul class="peview-item">
                                    <li>
                                        <p>公司名称</p>
                                        <p>{{item.smoName}}</p>
                                    </li>
                                    <li>
                                        <p>专业名称</p>
                                        <p>{{item.specialtyName}}</p>
                                    </li>
                                    <li v-if="item.jobTitle">
                                        <p>职位名称</p>
                                        <p>{{item.jobTitle}}</p>
                                    </li>
                                    <li v-if="item.phaseDesc">
                                        <p>项目类型</p>
                                        <p>{{item.phaseDesc}}</p>
                                    </li>
                                    <li v-if="item.managerName">
                                        <p>证明人</p>
                                        <p>{{item.managerName}}</p>
                                    </li>
                                    <li v-if="item.managerMobile">
                                        <p>证明人电话</p>
                                        <p>{{item.managerMobile}}</p>
                                    </li>
                                    <li style="display:block;" v-if="item.workDesc">
                                        <p>项目描述</p>
                                        <p>{{item.workDesc}}</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul v-if="personlist.projectExpList1==''">
                            <li>暂无数据</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>

    </div>

</template>

<script>

    import Cookies from 'js-cookie'
    import { getSmsCode2 } from '@/request/api'
    import { addperson } from '@/request/api'
    import { addsbtn } from '@/request/api'

    export default {
        data() {
            return {
                peviewstatus: false,
                userId: "",
                id: '',
                childid: '',
                smsCode: '',
                mobile: "",
                imgcodeinput: '',
                Verification: true,
                time: 60,
                auth_timer: null,
                personlist: {},
                imgurl: this.Common.imgurl,
                crcid: ''
            }
        },
        methods: {
            closePeview(data) {
                this.peviewstatus = data
            },
            closePeview() {
                this.peviewstatus = false;
            },
            search() {
                if (this.mobile == "" || this.smsCode == "") {
                    this.$message.error("手机号和验证码不能为空");
                } else {
                    addperson(this.mobile, this.smsCode).then((res) => {
                        if (res.data.code == "00000") {
                            this.peviewstatus = true;
                            this.personlist = res.data.data;
                            this.crcid = res.data.data.userId;
                        } else {
                            this.$message.error(res.data.message);
                        }

                    }).catch((err) => {
                        console.log(err)
                    })
                }


            },
            add() {
                if (this.crcid == "") {
                    // this.$message.error("请先搜索要添加的CRC人员");
                    this.$message({
                                message: '请先搜索要添加的CRC人员',
                                type: 'error',
                                duration: 1200
                            });
                } else {
                    addsbtn(this.userId, this.crcid).then((res) => {
                        if (res.data.code =="00000") {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                            });
                            this.mobile='';
                            this.crcid='';
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
                }
            },
            // 发送验证码
            send() {
                if (this.mobile == "") {
                    this.$message.error('手机号码不能为空');
                } else {
                    if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
                        this.$message.error("手机号码格式错误");
                    } else {
                        getSmsCode2(this.mobile).then((res) => {
                            let msg = res.data.message;
                            if (res.data.code == "00000") {
                                this.$message({
                                    message: msg,
                                    type: 'success'
                                });
                                // 倒计时
                                this.Verification = false;      //点击button改变v-show的状态
                                this.auth_timer = setInterval(() => {  //定时器设置每秒递减
                                    this.time--;        //递减时间
                                    if (this.time <= 0) {
                                        this.Verification = true;    //60s时间结束还原v-show状态并清除定时器
                                        clearInterval(this.auth_timer);
                                        this.auth_timer = null;
                                        this.time = 60;
                                    }
                                }, 1000)

                            } else {
                                this.$message.error(msg);
                            }
                        }).catch((err) => {
                            console.log(err)
                        })
                    }
                }
            }
        },
        mounted() {
            this.userId = Cookies.get("userid");
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tips {
        margin-top: 50px;
        font-size: 18px;
    }

    .peview ul li li {
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/company/addperson.vue